<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="box">
          <h1 class="title">GPS端末検索</h1>
          <div class="field">
            <div class="control">
                <input class="input" type="text" placeholder="端末UID" v-model="search_uid">
            </div>
          </div>
          <input type="button" class="button is-primary" value="クリア" v-on:click="searchClear">
        </div>
        <div v-if="user.permission.super_user">
          <router-link to="/settings/device/new">GPS端末新規登録</router-link>
        </div>
        <table class="table is-bordered pricing__table is-fullwidth">
          <thead>
            <tr>
              <th v-for="header in headers" v-bind:key="header.id">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in devices(search_uid)" v-bind:key="item.id">
              <td>{{ item.uid }}</td>
              <td>{{ item.disp_name }}</td>
              <td v-if="item.activate_flag === '1'">利用中</td>
              <td v-else class="has-text-danger">利用停止中</td>
              <td>{{ item.created_at }}</td>
              <td>
                <router-link :to="{ name: 'editDevice', params: { deviceId: item.id }}">
                  <button class="button is-link">編集</button>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data: function(){
    return {
      search_uid: '',
      headers:['UID','名称','状態','最終更新日時','操作'],
    }
  },
  computed: {
    ...mapGetters({
      devices: 'item/selectDevice'
    }),
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  mounted () {
    this.$store.dispatch('item/getDevice', {})
  },
  methods: {
    searchClear () {
      this.search_uid = '';
    },
  }
}
</script>